import { CycleWithRels } from '@statsbomb/parachute-types';
import { atom } from 'jotai';
import { atomWithSuspenseQuery } from 'jotai-tanstack-query';
import { comparisonIdAtom } from '@/atoms/queryParams';
import { sortCyclesBySeasonAndComp } from '@/utils/cycles';
import { objSnakeToCamel } from '@/utils/queries';
import { fetchClientAtom } from '../client';

export const rawPlayerComparisonCyclesAtom = atomWithSuspenseQuery(get => {
  const { fetch } = get(fetchClientAtom);
  const queryKey = ['playerComparisonCycles', get(comparisonIdAtom)] as const;

  const queryFn = async ({ queryKey: [, comparisonId] }: { queryKey: typeof queryKey }) => {
    if (!comparisonId) return [];
    return (await fetch(`/player/${comparisonId}/cycles`)) as CycleWithRels[];
  };

  return { queryKey, queryFn };
});

export const playerComparisonCyclesAtom = atom(async get => {
  const rawCycles = await get(rawPlayerComparisonCyclesAtom);
  return rawCycles.data.map(objSnakeToCamel);
});

export const playerComparisonCyclesOrderedAtom = atom(async get => {
  const cycles = await get(playerComparisonCyclesAtom);
  return sortCyclesBySeasonAndComp(cycles);
});
